<template>
  <v-container>
    <v-card>
      <slot name="title"></slot>
      <div style="overflow-x: auto; width: 100%">
        <div style="min-width: 300px; height: 300px; position: relative">
          <canvas ref="chartCanvas"></canvas>
        </div>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import Chart from "chart.js";

export default {
  props: {
    chartType: {
      type: String,
      default: "bar",
    },
    chartData: {
      type: Object,
      required: true,
    },
    chartOptions: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            ticks: {
              autoSkip: false,
            },
          },
        },
      }),
    },
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.renderChart();
      },
    },
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      if (this._chart) {
        this._chart.destroy(); // Hapus chart lama agar tidak dobel
      }

      const canvas = this.$refs.chartCanvas;
      const ctx = canvas.getContext("2d");

      const dataLength = this.chartData.labels?.length || 0;
      const barWidth = 10;
      canvas.width = dataLength * barWidth;

      this._chart = new Chart(ctx, {
        type: this.chartType,
        data: this.chartData,
        options: this.chartOptions,
      });
    },
  },
};
</script>
